import "./_skeleton.scss";

/**
 * Generic shimmering placeholder bar. Pure presentation - no loading-state
 * logic of its own; callers decide when to render it (e.g. Table's
 * SkeletonRows, StatCards) and how many/what shape.
 */
const Skeleton = ({ width = "100%", height = "14px", radius = "4px", className = "" }) => (
  <div
    className={`skeleton ${className}`.trim()}
    style={{ width, height, borderRadius: radius }}
  />
);

export default Skeleton;
